import { normalizeStringInObject } from "../utils/normalize";
import axios from './../helper/axiosIntanceApiZalo';

function getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach(key => formData.append(key, object[key]));
    return formData;
}
const accessToken= (params)=>{
    return axios.post('/accessToken', getFormData(normalizeStringInObject(params)));
}
const getConversation = (params) => {
    return axios.post('/conversation', getFormData(normalizeStringInObject(params)));
};
const getListRecentChat = (params) => { 
    return axios.post(`/listRecentChatInArray`, normalizeStringInObject(params));
};
const sendMessage = (params) => {
    return axios.post(`/sendMessage`, getFormData(normalizeStringInObject(params)));
};
const deleteOa = (params) => {
    return axios.post(`/deleteOa`, getFormData(normalizeStringInObject(params)));
};
const checkPermissionMessage = (params) => {
    return axios.post(`/checkPermissionMessage`, normalizeStringInObject(params));
};
const updateUserResponseMessageItem = (params) => {
    return axios.post(`/updateUserResponseMessageItem`, normalizeStringInObject(params));
};


export default {
    getConversation,
    getListRecentChat,
    sendMessage,
    accessToken,
    deleteOa,
    checkPermissionMessage,
    updateUserResponseMessageItem
}
